import Loadable from "react-loadable";
import LoadingComponent from "../../commons/loader";

export default [
  {
    path: "/dashboard",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/index"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/commissions",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/commissions"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/team-monitoring",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/team-monitoring"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/marketing-partners",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/marketing"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/marketing-partners/create",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/marketing/pages/create"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/marketing-partners/submit/:id",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/marketing/pages/submit"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/marketing-partners/view/:id",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/marketing/pages/view"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/calendar",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/calendar"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/reservation"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/e-booking",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/e-booking"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/cis/buyer-information/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/reservation/components/buyer-information"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/cis/personal-information/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () =>
        import("./pages/reservation/components/personal-information"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/cis/spouse-information/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/reservation/components/spouse-information"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/cis/spouse-information/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/reservation/components/spouse-information"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/cis/co-buyer-information/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () =>
        import("./pages/reservation/components/co-buyer-information"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/cis/client-purchase-journal/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () =>
        import("./pages/reservation/components/client-purchase-journal"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/cis/attachments/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/reservation/components/attachments"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/cpra/property-info/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/reservation/components/property-info"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/cpra/attachments/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/reservation/components/cpra-attachments"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/reservation/summary/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () =>
        import("./pages/reservation/components/reservation-summary"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/reservation/:rNo/view/property-scheme/:view",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/reservation/components/property-info"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/e-booking/:rNo/view/property-scheme/:view",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/e-booking/components/property-info"),
      loading: LoadingComponent,
    }),
  },

  {
    path: "/dashboard/customer-360",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/list/:page",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/lead",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360/pages/leadForm"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/buyer/purchase-history/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360/pages/purchase-history"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/lead/form",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () =>
        import("./pages/customer360/pages/leadForm/create-lead-form"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/lead/form/confirm/:id",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () =>
        import(
          "./pages/customer360/pages/leadForm/edit-lead-form/confirm-submission"
        ),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/lead/form/review/:page/:id",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () =>
        import(
          "./pages/customer360/pages/leadForm/edit-lead-form/renewal-lead-form"
        ),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/lead/form/:page/:id",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360/pages/leadForm/edit-lead-form"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/buyer/form/:page/:id",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360/pages/leadForm/edit-lead-form"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/my-reservations",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360/pages/my-reservations"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/customer-observation",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360/pages/customer-observation"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/customer-transfer",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360/pages/customer-transfer"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/customer-transfer/history",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () =>
        import("./pages/customer360/pages/customer-transfer/pages/history"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/customer-transfer/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () =>
        import("./pages/customer360/pages/customer-transfer/pages/request"),
      loading: LoadingComponent,
    }),
  },
  // {
  //   path: "/dashboard/customer-360/customer-transfer/request/1",
  //   exact: true,
  //   authL: true,
  //   component: Loadable({
  //     loader: () =>
  //       import("./pages/customer360/pages/customer-transfer/pages/request"),
  //     loading: LoadingComponent
  //   })
  // },

  {
    path: "/dashboard/customer-360/observation/form/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360/pages/observation"),
      loading: LoadingComponent,
    }),
  },
  {
    path: "/dashboard/customer-360/observation-list/:leadId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/customer360/pages/observation-list"),
      loading: LoadingComponent,
    }),
  },
];
